import { Col } from '../../components/custom';

export default function CxTrends()
{
    return (
        <Col id='cxTrends' className='perspectives'>
            <Col className='banner'>
                <span className='title'>Monitoring CX Trends Over Time</span>
                <span className='desc'>See the signals before they spike. Spot the drift before it derails.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Challenge</span>
                <span className='desc bold'>Customer satisfaction isn't static — it evolves.</span>
                <span className='descsmall'>A single NPS or CSAT score offers a snapshot, but not the full story. Without continuous monitoring, subtle shifts in experience can go unnoticed until complaints (or churn) escalate. Many organizations track scores, but don't analyze their trajectory over time.</span>
            </Col>
            <Col className='section'>
                <span className='title'>Our Philosophy</span>
                <span className='desc bold'>CX performance should be treated like any key business metric — monitored, modeled, and managed.</span>
                <span className='descsmall'>We believe organizations need to move from reactive survey analysis to proactive trend detection. This means looking at customer satisfaction and NPS not just in isolation, but as part of a dynamic system that reflects customer health over time.</span>
            </Col>
            <Col className='section'>
                <span className='title'>The Monitoring Framework</span>
                <span className='desc'>A time-aware approach to tracking and interpreting CX metrics:</span>
                <ul>
                    <li className='descsmall'>
                        <strong>Structured Feedback Collection at Intervals</strong>
                        <ul>
                            <li className='descsmall'>Collect CSAT, NPS, or feature-specific feedback on a weekly, monthly, or quarterly cadence.</li>
                            <li className='descsmall'>Ensure survey timing aligns with critical touchpoints or lifecycle stages.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Time Series Analysis</strong>
                        <ul>
                            <li className='descsmall'>Plot NPS/CSAT trends to detect fluctuations over time.</li>
                            <li className='descsmall'>Identify upward or downward drifts, seasonality, and inflection points.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Control Charts & Moving Averages</strong>
                        <ul>
                            <li className='descsmall'>Use statistical control charts to distinguish natural variability from real change./</li>
                            <li className='descsmall'>Apply moving averages to smooth data and highlight sustained trends.</li>
                        </ul>
                    </li>
                    <li className='descsmall'>
                        <strong>Root Cause Correlation</strong>
                        <ul>
                            <li className='descsmall'>Overlay key business events (e.g., product updates, support changes, market shifts) to contextualize movement in scores.</li>
                            <li className='descsmall'>Detect patterns tied to specific cohorts or events.</li>
                        </ul>
                    </li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>What This Enables</span>
                <ul>
                    <li className='descsmall'><strong>Proactive CX Management</strong> — Intervene early before negative trends escalate.</li>
                    <li className='descsmall'><strong>Pulse Monitoring by Segment</strong> — Track customer experience by region, product line, or lifecycle stage.</li>
                    <li className='descsmall'><strong>Data-Driven Storytelling</strong> — Provide leadership with clear narratives tied to score movement.</li>
                    <li className='descsmall'><strong>Continuous Improvement</strong> — Inform quarterly planning with real-time insights, not just end-of-year reports.</li>
                </ul>
            </Col>
            <Col className='section'>
                <span className='title'>The Takeaway</span>
                <span className='desc bold'>Don't just track CX. Trend it. Test it. Trust it.</span>
                <span className='descsmall'>With continuous monitoring and advanced analytics, organizations can stay ahead of customer dissatisfaction and make smarter, faster experience decisions.</span>
            </Col>
        </Col>
    )
}